import { render, staticRenderFns } from "./PflegeGiessenTable.vue?vue&type=template&id=d32f2e74"
import script from "./PflegeGiessenTable.vue?vue&type=script&lang=js"
export * from "./PflegeGiessenTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports